import { render, staticRenderFns } from "./BtnDeleteBySchoolCycleGrade.vue?vue&type=template&id=61ad028e"
import script from "./BtnDeleteBySchoolCycleGrade.vue?vue&type=script&lang=js"
export * from "./BtnDeleteBySchoolCycleGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports